/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planner_BudgetInputs */

const en_planner_budget = /** @type {(inputs: Planner_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget in € (optional)`)
};

const de_planner_budget = /** @type {(inputs: Planner_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget in € (optional)`)
};

/**
* | output |
* | --- |
* | "Budget in € (optional)" |
*
* @param {Planner_BudgetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_budget = /** @type {((inputs?: Planner_BudgetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_BudgetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_budget(inputs)
	return en_planner_budget(inputs)
});